const ticketInfo = {
  state: {
    tripPerson: []
  },
  mutations: {
    tripPerson (state, payload) {
      state.tripPerson = state.tripPerson.concat(payload)
    }
  }
}
export default ticketInfo



// WEBPACK FOOTER //
// ./src/store/modules/inlandTicket.js